import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, ShoppingBag } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { VehicleCard } from "@/components/VehicleCard";
import { Button } from "@/components/ui/button";

const SavedVehicles = () => {
  const [items, setItems] = useState(null);

  const load = () => {
    api.get("/me/saved-vehicles").then((r) => setItems(r.data)).catch(() => setItems([]));
  };
  useEffect(() => { load(); }, []);

  const remove = async (vehicleId) => {
    try {
      await api.delete(`/me/saved-vehicles/${vehicleId}`);
      toast.success("Removed from saved.");
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="saved-vehicles-page">
      <div className="flex items-end justify-between">
        <div>
          <p className="text-xs uppercase tracking-widest text-slate-500 font-semibold">Your shortlist</p>
          <h1 className="mt-2 font-display text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">
            Saved vehicles
          </h1>
        </div>
        <Button asChild variant="outline" className="border-brand text-brand hover:bg-brand hover:text-white">
          <Link to="/account">← Account</Link>
        </Button>
      </div>

      {items === null ? (
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="h-[380px] bg-slate-100 rounded-2xl animate-pulse" />
          ))}
        </div>
      ) : items.length === 0 ? (
        <div className="mt-16 text-center bg-slate-50 border border-slate-200 rounded-2xl py-16" data-testid="saved-empty">
          <Heart size={30} className="mx-auto text-slate-300" />
          <p className="mt-4 font-display text-xl text-slate-800">You haven't saved anything yet</p>
          <p className="mt-2 text-sm text-slate-500">
            Tap the heart on any car to keep track of it here.
          </p>
          <Button asChild className="mt-6 bg-brand hover:bg-brand-hover text-white">
            <Link to="/inventory">
              <ShoppingBag size={16} /> Browse inventory
            </Link>
          </Button>
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="saved-grid">
          {items.map((s) => (
            <div key={s.id} className="relative" data-testid={`saved-item-${s.vehicle_id}`}>
              <VehicleCard vehicle={s.vehicle} />
              <button
                onClick={() => remove(s.vehicle_id)}
                className="absolute top-3 right-3 z-10 bg-white/90 backdrop-blur px-2.5 py-1.5 rounded-full text-xs font-semibold text-rose-600 border border-slate-200 hover:bg-white transition-colors"
                data-testid={`unsave-btn-${s.vehicle_id}`}
              >
                <Heart size={13} className="fill-current inline" /> Unsave
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SavedVehicles;
